/*
 * 苏州海管家物流科技有限公司（https://www.hgj.com/）.
 * 苏公网安备32059002003385号 © 2015-2023 Hgj.com All Rights Reserved. | 苏ICP备15030950号.
 * @Date: 2023.09.05.
 * @Author
 * @Description 恪保项目 - 接口地址 .
 **/

const i = '/saas-insurance'

const urls = {
  getUserDetailUrl: `${i}/users/detail`, // 用户 信息 用户 详情
  postCluesUrl: `${i}/clients/clues`, // 线索上传
  postQueriesUrl: `${i}/insures/queries/pages`, // 货运险列表
  postCrossQueriesUrl: `${i}/insures/queries/cross/pages`, // 跨境货运险列表
  postPageUrl: `${i}/insures/operations/apply`, // 请求保险供应商，获取跳转页面
  delOperationUrl: `${i}/insures/operations`, // url${id} 删除
  postExportUrl: `${i}/insures/queries/export`, // 货运险列表导出
  postCrossExportUrl: `${i}/insures/queries/cross/export`, // 跨境货运险列表导出
  getOpCopyUrl: `${i}/insures/operations`, // /{id}/copy复制
  postFbPageUrl: `${i}/insures/operations/fb-apply`, // 请求保险供应商（跨境），获取跳转页面
  getBillUrl: `${i}/insures/operations/settlement`, // 账单列表
  getFreightListUrl: `${i}/freight-duty/orders/pages`, // 货运责任险列表
  freightDetailUrl: `${i}/freight-duty/orders`, // 新增、编辑货运责任险
  exportFreightUrl: `${i}/insures/queries/duty-orders/export`, // 到处货运险
  wyDetailUrl: `${i}/insures/operations/wyDetail`, // 无忧获取编辑url
  postCluesTypeUrl: `${i}/clients/clues/type`, // 选择保险类型提交
  postReminderUrl: `${i}/insures/operations/reminder`, // 恪保催单
  postTemplateFileUrl: `${i}/insures/operations/loadWithDrawFile`, // 恪保注销附件下载接口
  postQuitApplyUrl: `${i}/insures/operations/policyWithDraw`, // 恪保注销申请接口
  postQuitStatusUrl: `${i}/insures/operations/status`, // 恪保注销状态查询接口
  postCluesUrlHaike: `${i}/job/send/clue`, // 线索上传通知海克
  getInsuredUserList: `${i}/insures/queries/insuredUserList`, // 被保险人列表
  postExcelImport: `${i}/insures/operations/excel-import`, // kb导入
  postAi: `${i}/insures/ai/file`, // 获取AI识别结果
  postAiResults: `${i}/insures/operations/apply`, // 提交AI识别结果
  hgjExcelImport: `${i}/insures/hgj/excel-import`, // hgj导入
  hgjCrossExcelImport: `${i}/direct/cross/import`, // 跨境hgj导入
  getUserGuideUrl: `/all-port/storybrooke-assistor/business-data/get-use-guide`, // 用户操作手册
}

export default urls
